import { Link, useParams } from "react-router-dom";

export default function HeroBanner() {
  const { lang = "en" } = useParams();
  return (
    <section className="relative overflow-hidden bg-ink text-white">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_20%,rgba(232,93,79,.35),transparent_32%),linear-gradient(135deg,#111827,#17322e)]" />
      <div className="container-page relative grid min-h-[520px] items-center gap-8 py-16 md:grid-cols-[1.05fr_.95fr]">
        <div className="max-w-xl">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.18em] text-gold">Global ready commerce</p>
          <h1 className="text-4xl font-black leading-tight md:text-6xl">Premium goods, local payment, worldwide reach.</h1>
          <p className="mt-5 text-lg text-slate-200">A first-phase cross-border store with products, checkout, manual payment review, admin workflows, SEO and tracking foundations.</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link className="btn-primary bg-coral hover:bg-white hover:text-ink" to={`/${lang}/products`}>Shop collection</Link>
            <Link className="btn-secondary border-white/30 bg-white/10 text-white hover:bg-white hover:text-ink" to={`/${lang}/about`}>Our story</Link>
          </div>
        </div>
        <div className="grid gap-4 sm:grid-cols-2">
          {["Smart travel kit", "Creator desk gear", "Everyday carry"].map((name, i) => (
            <div key={name} className={`rounded-lg bg-white/12 p-4 shadow-soft ${i === 1 ? "sm:mt-10" : ""}`}>
              <div className="aspect-[4/5] rounded-md bg-gradient-to-br from-white/30 to-white/5" />
              <p className="mt-3 font-semibold">{name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
